module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/becca-duffee-2c7b16dc2583b416e324508ab140b00e.jpg";